import { Component } from '@angular/core';
import { MenuButtonsComponent } from './menu-buttons/menu-buttons.component';
import { MenuContainerComponent } from './menu-container/menu-container.component';

@Component({
    selector: 'app-menu',
    imports: [
        MenuButtonsComponent,
        MenuContainerComponent
    ],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.css'
})
export class MenuComponent {

}
